import {
  Button,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { noop } from '@blockpulse3/data/shared';

import { SummaryCompanyInfos } from './SummaryCompanyInfos';
import { SummaryDocuments } from './SummaryDocuments';
import { SummaryRoleInfos } from './SummaryRoleInfos';

type Props = {
  onCancel?: () => void;
  onSubmit: () => void;
};

/**
 * SummaryStep.
 * Summary step for the SPV funnel.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function SummaryStep({ onCancel = noop, onSubmit }: Props): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nSPVFormWizard = useTranslations('SPVSummaryStep');

  const handleStepCancel = (): void => {
    onCancel();
  };

  const handleWizardSubmit = (): void => {
    onSubmit();
  };

  return (
    <>
      <CardHeader as={Stack} spacing="2">
        <Heading size="lg">{i18nSPVFormWizard('Title')}</Heading>
        <Text color="gray.600" fontSize="lg">
          {i18nSPVFormWizard('SubTitle')}
        </Text>
      </CardHeader>
      <Divider />
      <CardBody as={Stack} spacing="4">
        <SummaryCompanyInfos />
        <SummaryRoleInfos />
        <SummaryDocuments />
      </CardBody>
      <CardFooter as={Stack} direction={{ base: 'column', md: 'row' }} spacing="4">
        <Button variant="secondary" w="full" onClick={handleStepCancel}>
          {i18nGeneral('Back')}
        </Button>
        <Button w="full" onClick={handleWizardSubmit}>
          {i18nGeneral('SubmitAndPay')}
        </Button>
      </CardFooter>
    </>
  );
}

export type SummaryStepProps = Props;
